import React from 'react';
import '../assets/Home.css';

function LightBox({item, custId}) {   
    let imgCount = item[custId].images.length;
    if (imgCount <= 0 ) {
        imgCount = 'No Images'
    }
    else {
        imgCount = imgCount + ' images' 
    }
    return (
        <div id="lightbox">
            <div className="container">
                <p style={{textAlign:"left",color:"gray",padding:"5px 0",textTransform:"capitalize"}}>{imgCount}</p>
                <div className="row">
                {item[custId].images.map((image, index) => 
                    <div key={index}  className={`column img${index}`} >
                        <a href={image.photo} data-fancybox="images" style={{display:"block"}}>
                            <img
                                style={{width:"100%"}}
                                src={image.photo}
                                loading="lazy"
                                alt={image.photo_text}
                            />
                        </a>
                    </div>
                )} 
                </div>
            </div>
        </div>
    );
}
export default LightBox;